import { useSearchParams, useNavigate } from "react-router-dom";
import { toastService } from "../../providers";
import CustomUnauthorized from "../../components/ui/CustomUnauthorized/CustomUnauthorized";
import { useResetPassword } from "../../hooks/queries/useAuthQueries";
import { usePasswordForm } from "./hooks/usePasswordForm";
import PasswordPageWrapper from "../../components/auth/PasswordPageWrapper/PasswordPageWrapper";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const activationToken = searchParams.get("token");
  const navigate = useNavigate();

  const { mutate: resetPassword, isPending } = useResetPassword();
  const { control, handleSubmit, validations } = usePasswordForm();

  const onSubmit = (values) => {
    resetPassword(
      { password: values.password, token: activationToken },
      {
        onSuccess: () => {
          toastService.success("Password reset successfully.");
          setTimeout(() => {
            navigate("/auth/login");
          }, 1000);
        },
        onError: (_error) => {
          toastService.error("Something went wrong! Please try again.");
        },
      },
    );
  };

  if (!activationToken) {
    return (
      <CustomUnauthorized
        leftTitle="Access Denied!"
        leftMessage="Please ensure you clicked the full link from your email."
        actions={[
          {
            label: "Back To Home",
            href: "/",
          },
        ]}
      />
    );
  }

  return (
    <PasswordPageWrapper
      title="New Password"
      subtitle="Set up a new password to access your account"
      control={control}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isPending}
      validationRules={validations}
      buttonLabel="Set Password"
    />
  );
}

export default ResetPassword;
